import { render, staticRenderFns } from "./ot-user-status-tags-wrapper.vue?vue&type=template&id=d46031e2&scoped=true&"
import script from "./ot-user-status-tags-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-user-status-tags-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-user-status-tags-wrapper.vue?vue&type=style&index=0&id=d46031e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46031e2",
  null
  
)

export default component.exports